<template>
  <el-popover
      :disabled="disabledVisible"
      placement="top"
      width="160"
      v-model="visible">
    <p>
      <slot>确定删除该记录?</slot>
    </p>
    <div style="text-align: right; margin: 0">
      <el-button size="mini" type="text" @click="visible = false">取消</el-button>
      <el-button type="primary" size="mini" @click="confirm">确定</el-button>
    </div>
    <el-link type="danger" :disabled="disabledVisible" slot="reference">删除</el-link>
  </el-popover>
</template>

<script>
export default {
  name: "confirm",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler(newVal) {
        this.disabledVisible = newVal
      }
    }
  },
  data() {
    return {
      visible: false,
      disabledVisible: false
    }
  },
  methods: {
    confirm() {
      this.visible = false
      this.$emit('confirm')
    },
  }
}
</script>

<style scoped>

</style>